import React, { useState } from 'react'
import './SummaryHeader.scss'
// Hiding risk score badge from summary right panel
// import { Risk } from 'constants/chartData'
import DsButton from 'components/ds/Button'
import DsIcon from 'components/ds/Icon'
import { Badge } from 'components/ds/Badge'
import strings from 'strings'
import { getTabByReportType } from 'constants/constantVariables'
import { getSourceLabel } from 'constants/reports/registry'
import AuthService from 'tools/AuthService'
import { reportDrawerSupported } from 'constants/utilityFunctions'
import SosSearchDrawer from './Components/SosSearchDrawer'
import { useHistory } from 'react-router-dom'
import queryString from 'query-string'
import CreditCost from 'components/shared/CreditCost'

const summaryStrings = strings.APPLICANT.SUMMARY

const SummaryHeader = (props) => {
    const {
        lastUpdate,
        // Hiding risk score badge from summary right panel
        // risk,
        summaryTabChange,
        showReportDrawer,
        applicantId,
        reportId,
        loading,
        requestDecision,
        reportInfo,
        getDataDisabled,
        creditUsageEnabled,
        creditCosts,
        isBrokerCustomer,
        updateSummaryCard,
        anonymize
    } = props

    const { title, entityName, status, type, entityId, entityType, creditCost } = reportInfo || {}
    const [openSearchDrawer, setOpenSearchDrawer] = useState(false)
    const history = useHistory()

    const nameDisplay = anonymize ? entityType : entityName

    // Hiding risk score badge from summary right panel
    // const colorCodes = Risk.find(st => st.value === risk) || {};
    const tabIndex = getTabByReportType(type)

    const reportDrawerOrChangeTab = () => {
        if(type === 'LEXIS_VERIFICATION'){
            summaryTabChange(tabIndex)
            return
        }
        if(type === 'MOTUS'){
            summaryTabChange(tabIndex)
            return
        }

        if (type === 'SOS') {
            setOpenSearchDrawer(true)
            return
        }
        // Background reports open in the Background tab (full report) rather than the
        // limited summary drawer. The bgvEntity params tell that tab which saved report to open.
        if (type === 'LEXIS_BACKGROUND') {
            history.push({ search: queryString.stringify({ tab: 'bgv', bgvEntity: entityId, bgvEntityType: entityType }) })
            return
        }
        if (status?.value === 'FOUND' && reportDrawerSupported(type, entityType)) {
            showReportDrawer(applicantId, entityId, type, entityType)
            return
        }
        summaryTabChange(tabIndex)
    }

    const notRun = status?.value === 'NOT_DONE'

    return (
        <>
            <div className='summaryHeader'>
                <div className='summaryHeaderTitle'>
                    <div className='summaryHeaderHeading'>
                        <h5 className='mb-0'> {title} </h5>
                        {notRun &&
                            <Badge tone='closed' dot={false}>{summaryStrings.NOT_RUN}</Badge>
                        }
                    </div>
                    {nameDisplay && type !== 'FMCSA' && type !== 'SOS' && <p className='mb-0 entityName'>{nameDisplay}</p>}
                    {lastUpdate &&
                        <p className='summaryProvenance mb-0'>
                            {getSourceLabel(type)} · {summaryStrings.PULLED} {lastUpdate}
                        </p>
                    }
                </div>
                <div className='summaryHeaderInfo'>
                    {
                        !isBrokerCustomer && (
                    <DsButton
                        variant='ghost'
                        size='small'
                        className='summaryHeaderButton'
                        onClick={() => reportDrawerOrChangeTab()}
                        loading={loading}
                        id={'view-more-' + reportId}
                    >
                        {summaryStrings.VIEW_MORE}
                    </DsButton>
                        )
                    }
                  {!isBrokerCustomer && !AuthService.isReadOnlyUser() && status?.value !== 'FOUND' &&
                        <DsButton
                            variant='secondary'
                            size='small'
                            className='summaryHeaderButton'
                            startIcon={<DsIcon name='search' size={16} />}
                            onClick={requestDecision}
                            id={'get-data-' + reportId}
                            loading={loading}
                            disabled={getDataDisabled}
                        >
                            {summaryStrings.GET_DATA}
                            {creditUsageEnabled &&
                                <span className='summaryCreditPill'>
                                    <CreditCost cost={creditCost} />
                                </span>
                            }
                        </DsButton>
                    }
                </div>
            </div>
            <SosSearchDrawer
                open={openSearchDrawer}
                onClose={() => setOpenSearchDrawer(false)}
                requestDecision={requestDecision}
                applicantId={applicantId}
                creditCosts={creditCosts}
                updateSummaryCard={updateSummaryCard}
            />
        </>
    )
}

export default SummaryHeader
